import CasePaper from "../../components/casePaper/CasePaper";

export default CasePaper;
